import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { fmtDateTime } from "@/lib/format";
import { Search } from "lucide-react";

const ENTITY_TYPES = ["order", "stock_batch", "stock_transfer", "product", "customer", "user", "role", "branch", "settings", "insurance_scheme", "category"];

export default function Audit() {
  const [logs, setLogs] = useState([]);
  const [entity, setEntity] = useState("all");
  const [q, setQ] = useState("");

  const load = useCallback(() => {
    api.get("/audit-logs", { params: { entity_type: entity === "all" ? undefined : entity } }).then((r) => setLogs(r.data));
  }, [entity]);
  useEffect(() => { load(); }, [load]);

  const filtered = logs.filter((l) => {
    if (!q) return true;
    const hay = `${l.action} ${l.description} ${l.actor_name} ${l.entity_type}`.toLowerCase();
    return hay.includes(q.toLowerCase());
  });

  return (
    <div>
      <PageHeader title="Audit Trail" subtitle="Immutable record of who did what, and when — across all branches" />
      <Card className="p-3 mb-4 shadow-sm flex flex-col sm:flex-row gap-3">
        <div className="relative flex-1">
          <Search className="h-4 w-4 absolute left-3 top-2.5 text-muted-foreground" />
          <Input data-testid="audit-search-input" placeholder="Search action, description, user…" value={q} onChange={(e) => setQ(e.target.value)} className="pl-9" />
        </div>
        <Select value={entity} onValueChange={setEntity}>
          <SelectTrigger data-testid="audit-entity-filter" className="w-full sm:w-52"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All entities</SelectItem>
            {ENTITY_TYPES.map((e) => <SelectItem key={e} value={e}>{e.replace(/_/g, " ")}</SelectItem>)}
          </SelectContent>
        </Select>
      </Card>

      <Card className="shadow-sm overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-muted text-xs uppercase tracking-wider text-muted-foreground text-left">
            <tr><th className="py-2.5 px-3">Timestamp</th><th className="py-2.5 px-3">Action</th><th className="py-2.5 px-3">Entity</th>
            <th className="py-2.5 px-3">Description</th><th className="py-2.5 px-3">Actor</th></tr>
          </thead>
          <tbody>
            {filtered.length === 0 && <tr><td colSpan={5} className="py-10 text-center text-muted-foreground">No audit records</td></tr>}
            {filtered.map((l) => (
              <tr key={l.id} className="border-t border-border hover:bg-muted/50">
                <td className="py-2 px-3 font-mono text-xs text-muted-foreground whitespace-nowrap">{fmtDateTime(l.timestamp)}</td>
                <td className="py-2 px-3"><span className="text-xs font-semibold text-foreground">{l.action.replace(/_/g, " ")}</span></td>
                <td className="py-2 px-3 text-xs text-muted-foreground">{l.entity_type}</td>
                <td className="py-2 px-3 text-foreground">{l.description || "—"}</td>
                <td className="py-2 px-3 text-muted-foreground text-xs">{l.actor_name}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
